import { defineMessages } from 'react-intl';
import { faAlbumCollection, faUserMusic, faListMusic } from '@fortawesome/pro-solid-svg-icons';
import { Feature } from './types';

const {
  artistFeatureTitle,
  artistFeatureDescription,
  releaseFeatureTitle,
  releaseFeatureDescription,
  playlistFeatureTitle,
  playlistFeatureDescription
} = defineMessages({
  artistFeatureTitle: {
    id: 'sml.web.smartlinks.types.artist.title',
    defaultMessage: 'Artist Bio Link'
  },
  artistFeatureDescription: {
    id: 'sml.web.smartlinks.types.artist.description',
    defaultMessage: 'Bring together all of your streaming links, social media profiles, and more.'
  },
  releaseFeatureTitle: {
    id: 'sml.web.smartlinks.types.release.title',
    defaultMessage: 'Release Link'
  },
  releaseFeatureDescription: {
    id: 'sml.web.smartlinks.types.release.description',
    defaultMessage: 'Promote your singles and albums on multiple services.'
  },
  playlistFeatureTitle: {
    id: 'sml.web.smartlinks.types.playlist.title',
    defaultMessage: 'Playlist Link'
  },
  playlistFeatureDescription: {
    id: 'sml.web.smartlinks.types.playlist.description',
    defaultMessage: 'Convert and sync playlists, everywhere.'
  }
});
export const artistFeature = {
  title: artistFeatureTitle,
  description: artistFeatureDescription,
  forPremium: false,
  forBasic: false,
  icon: faUserMusic,
  link: '/artist',
  className: 'justify-content-center',
  position: {
    top: '200px'
  }
};
export const releaseFeature = {
  title: releaseFeatureTitle,
  description: releaseFeatureDescription,
  forPremium: false,
  forBasic: false,
  icon: faAlbumCollection,
  link: '/release',
  position: {
    top: '-100px'
  }
};
export const playlistFeature = {
  title: playlistFeatureTitle,
  description: playlistFeatureDescription,
  forPremium: false,
  forBasic: false,
  icon: faListMusic,
  link: '/playlist',
  position: {
    top: '200px',
    right: '0px'
  }
};
export const features: Feature[] = [artistFeature, releaseFeature, playlistFeature];
